import DefinitionsA from "../text/definitions_A.mdx";
import RubricA from "../text/rubric_A.mdx";
import {SummaryBar} from "../components/summary_bar";
import {frameworkA1Data, frameworkA1Options} from "./framework_A1";
import {frameworkA2Data, frameworkA2Options} from "./framework_A2";
import {frameworkA3Data, frameworkA3Options} from "./framework_A3";
import {frameworkA4Data, frameworkA4Options} from "./framework_A4";
import {frameworkA5Data, frameworkA5Options} from "./framework_A5";
import {frameworkA6Data, frameworkA6Options} from "./framework_A6";
import {frameworkB1Data, frameworkB1Options} from "./framework_B1";
import {frameworkB2Data, frameworkB2Options} from "./framework_B2";
import {frameworkC1Data, frameworkC1Options} from "./framework_C1";
import {frameworkC2Data, frameworkC2Options} from "./framework_C2";
import {frameworkD1Data, frameworkD1Options} from "./framework_D1";
import {frameworkD2Data, frameworkD2Options} from "./framework_D2";
import {frameworkD3Data, frameworkD3Options} from "./framework_D3";
import {frameworkD4Data, frameworkD4Options} from "./framework_D4";
import {frameworkD5Data, frameworkD5Options} from "./framework_D5";
import {frameworkD6Data, frameworkD6Options} from "./framework_D6";
import {frameworkD7Data, frameworkD7Options} from "./framework_D7";
import {frameworkD8Data, frameworkD8Options} from "./framework_D8";
import {frameworkD9Data, frameworkD9Options} from "./framework_D9";
import {frameworkD10Data, frameworkD10Options} from "./framework_D10";

import DefinitionsB from "../text/definitions_B.mdx";
import RubricB from "../text/rubric_B.mdx";
import DefinitionsC from "../text/definitions_C.mdx";
import RubricC from "../text/rubric_C.mdx";
import DefinitionsD from "../text/definitions_D.mdx";
import React from "react";

const idToContent = {
    "A": {
      "definitions": <DefinitionsA/>,
      "rubric": <RubricA/>,
      "results":[
        {
          "title": "Percentage of Dimensions Accurate and Consistent",
          "description": "In this context, a \"dimension\" is a combination of a system and an attribute. So Aegis Autonomy is one dimension, while C-Core Impact is another. These graphs show the percent of dimensions in which certain levels (50% and 65%) of respondents both agreed and picked the correct answer. For analysis in the full report, the 65% threshold was used to consider a dimension classification consistent.",
          "graphs": [
            {
              "description": "",
              "graph": <SummaryBar data={frameworkA1Data} options={frameworkA1Options}/>
            },
            {
              "description": "",
              "graph": <SummaryBar data={frameworkA2Data} options={frameworkA2Options}/>
            }
          ]
        },
        {
          "title": "User Classification Accuracy",
          "description": "These graphs show the overall user accuracy for each dimension, using Framework A. With some exceptions, users were more often accurate when classifying system impact using both versions of Framework A (with and without a rubric). Results for non-AI systems are represented with transparent bars.",
          "graphs": [
            {
              "description": "",
              "graph": <SummaryBar data={frameworkA3Data} options={frameworkA3Options}/>
            },
            {
              "description": "",
              "graph": <SummaryBar data={frameworkA4Data} options={frameworkA4Options}/>
            },
          ]
        },
        {
          "title": null,
          "description": "For each attribute and system, these graphs compare the classification performance of users who were given the full classification rubric versus those who were only given the classification labels. These graphs also show user accuracy but compare accuracy for the same dimension with or without a rubric. With some exceptions, users were more often accurate when they had the rubric.",
          "graphs": [
            {
              "description": "",
              "graph": <SummaryBar data={frameworkA5Data} options={frameworkA5Options}/>
            },
            {
              "description": "",
              "graph": <SummaryBar data={frameworkA6Data} options={frameworkA6Options}/>
            },
          ]
        }
      ],
    },
    "B": {
      "definitions": <DefinitionsB/>,
      "rubric": <RubricB/>,
      "results":[
        {
          "title": "Percentage of Dimensions Accurate and Consistent",
          "description": "In this context, a \"dimension\" is a combination of a system and an attribute. So Aegis Autonomy is one dimension, while C-Core Impact is another. This graph shows the percent of dimensions in which certain levels (50% and 65%) of respondents both agreed and picked the correct answer. For analysis in the full report, the 65% threshold was used to consider a dimension classification consistent.",
          "graphs": [
            {
              "description": "",
              "graph": <SummaryBar data={frameworkB1Data} options={frameworkB1Options}/>
            }
          ]
        },
        {
          "title": "User Classification Accuracy",
          "description": "This graph shows the overall user accuracy for each dimension, using Framework B. Results for non-AI systems are represented with transparent bars. Across systems, users more often accurately classified the system's impact, compared to the system's autonomy.",
          "graphs": [
            {
              "description": "",
              "graph": <SummaryBar data={frameworkB2Data} options={frameworkB2Options}/>
            }
          ]
        }
      ],
    },
    "C": {
      "definitions": <DefinitionsC/>,
      "rubric": <RubricC/>,
      "results":[
        {
          "title": "Percentage of Dimensions Accurate and Consistent",
          "description": "In this context, a \"dimension\" is a combination of a system and an attribute. So Aegis Autonomy is one dimension, while C-Core Impact is another. This graph shows the percent of dimensions in which certain levels (50% and 65%) of respondents both agreed and picked the correct answer. For analysis in the full report, the 65% threshold was used to consider a dimension classification consistent. This Framework had the highest percentage of combined autonomy and impact classifications that were consistent and accurate.",
          "graphs": [
            {
              "description": "",
              "graph": <SummaryBar data={frameworkC1Data} options={frameworkC1Options}/>
            }
          ]
        },
        {
          "title": "User Classification Accuracy",
          "description": "This graph shows the overall user accuracy for each dimension, using Framework C. Results for non-AI systems are represented with transparent bars. With the exception of Caster, users more often accurately classified the system's impact, compared to the system's autonomy.",
          "graphs": [
            {
              "description": "",
              "graph": <SummaryBar data={frameworkC2Data} options={frameworkC2Options}/>
            }
          ]
        }
      ],
    },
    "D": {
      "definitions": <DefinitionsD/>,
      "results":[
        {
          "title": "Percentage of Dimensions Accurate and Consistent",
          "description": "In this context, a \"dimension\" is a combination of a system and an attribute. So Aegis Autonomy is one dimension, while C-Core Impact is another. This graph shows the percent of dimensions in which certain levels (50% and 65%) of respondents both agreed and picked the correct answer. For analysis in the full report, the 65% threshold was used to consider a dimension classification consistent. In addition to Autonomy and Impact, Framework D included 7 additional attributes, which are not included in the overall percentage reported in the graph.",
          "graphs": [
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD1Data} options={frameworkD1Options}/>
            }
          ]
        },
        {
          "title": "User Classification Accuracy",
          "description": "These graphs show the overall user accuracy for each classified attribute by system. Classification accuracy was varied for some attributes, such as Sector and Data Collection. Meanwhile, some attributes had more consistent rates of accuracy across systems, such as Task and User. Finally, some systems had lower classification accuracy across attributes, such as FIQ and C-Core.",
          "graphs": [
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD9Data} options={frameworkD9Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD2Data} options={frameworkD2Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD3Data} options={frameworkD3Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD4Data} options={frameworkD4Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD5Data} options={frameworkD5Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD6Data} options={frameworkD6Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD7Data} options={frameworkD7Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD8Data} options={frameworkD8Options}/>
            },
            {
              "description": "",
              "graph":  <SummaryBar data={frameworkD10Data} options={frameworkD10Options}/>
            }
          ]
        }
      ],
    },
  };

export default idToContent;
